import { useState } from 'react'

import API from '../../../api/api'

export const useAmenityMarketplaceRequestAccess = (selectedBuilding) => {
  const [isLoading, setIsLoading] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)

  const handleRequestAccess = async () => {
    try {
      setIsLoading(true)
      await API.sendUpsellingMessage(
        { type: 'amenityPass' },
        selectedBuilding?.id || selectedBuilding?.value,
      )
      setShowSuccess(true)
    } catch (error) {
      console.error('Failed to send marketplace request:', error.message)
    } finally {
      setIsLoading(false)
    }
  }

  return { handleRequestAccess, isLoading, showSuccess, setShowSuccess }
}
